import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ApiDealerService } from '../core/services/api-dealer.service';
import { CommonService } from '../core/services/common.service';
import { LayoutModule } from '../layout/layout.module';
import { FooterComponent } from './components/footer/footer.component';
import { ForgetPasswordOtpComponent } from './components/forget-password-otp/forget-password-otp.component';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginHeaderComponent } from './components/login-header/login-header.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { PasswordChangeFormComponent } from './components/password-change-form/password-change-form.component';
import { RedirectionComponent } from './components/redirection/redirection.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { UpdatePasswordFormComponent } from './components/update-password-form/update-password-form.component';
import { BackgroundImageService } from './services/background-image.service';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    UpdatePasswordFormComponent,
    ForgotPasswordFormComponent,
    ForgetPasswordOtpComponent,
    HeaderComponent,
    LayoutComponent,
    SideMenuComponent,
    FooterComponent,
    PasswordChangeFormComponent,
    RedirectionComponent,
    LoginHeaderComponent,
    ForgetPasswordOtpComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  exports: [
    LoginComponent,
    UpdatePasswordFormComponent,
    HeaderComponent,
    LayoutComponent,
    SideMenuComponent,
    FooterComponent,
  ],
  providers: [
    BackgroundImageService,
    CommonService,
    ApiDealerService
  ],
})
export class ExtranetModule {}
